import * as React from 'react';
import {WithStyles} from '@material-ui/styles';
import {withStyles} from '@material-ui/core/styles';
import {CustomSwitchStyle as switchStyle} from './CustomSwitch.style';




interface IProps extends WithStyles<typeof switchStyle>{
  name: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
}


class CustomSwitch extends React.Component<IProps> {

  public render() {
    const { checked } = this.props;

    return (
      <label className={this.props.classes.label} onTouchStart={(e) =>{this.props.onChange(); e.preventDefault();}}>
        <input
          disabled={this.props.disabled}
          readOnly={true}
          className={this.props.classes.input}
          name={this.props.name}
          type="checkbox"
          checked={checked}
        />
        <span className={this.props.classes.slider} />
        <span role="slider" className={this.props.classes.thumb} style={{left:checked?36:0}} />
      </label>
    );
  }
}

export default withStyles(switchStyle)(CustomSwitch);



// WEBPACK FOOTER //
// ./src/components/economy/CustomSwitch.tsx